export default __webpack_public_path__ + "static/media/Tesla.f8d2c2b5.svg";